import { useQueryClient } from '@tanstack/react-query';
// mantine
import { Badge, Button, List } from '@mantine/core';
// components
// icons
import { Check } from 'lucide-react';
// utils
import { TBillingSubscriptionInfo } from '@newo/api/gateway';
import BillingMenu from '@/pages/Profile/components/Billing/components/BillingMenu';
import { useCompleteDevelopmentStageMutation } from '@/services/customer/profile/profile.queries.ts';

interface DevelopmentSubscriptionProps {
    data: TBillingSubscriptionInfo;
    onCancel: () => void;
    isCancelPending: boolean;
}

const DevelopmentSubscription = ({
    data,
    onCancel,
    isCancelPending
}: DevelopmentSubscriptionProps) => {
    const queryClient = useQueryClient();
    const {
        mutateAsync: completeDevelopmentStage,
        isPending: isCompleteDevelopmentStagePending
    } = useCompleteDevelopmentStageMutation();

    const startFreeTrial = async () => {
        try {
            await completeDevelopmentStage();
            queryClient.invalidateQueries({ queryKey: ['billing'] });
        } catch (error) {
            console.log(error);
        }
    };

    return (
        <div className="grid grid-cols-1 md:grid-cols-[1fr_max-content] gap-4">
            <div>
                <div className="text-xl font-bold mb-4 flex items-center gap-2">
                    <div>{data.product_name}</div>

                    <Badge className="capitalize" color="gray" variant="light">
                        Developer Mode
                    </Badge>
                </div>
                <List center icon={<Check />} size="sm" spacing="sm">
                    <List.Item>
                        Test everything in Developer Mode (with a short intro
                        message before results)
                    </List.Item>
                    <List.Item>
                        Start your trial for results without the intro message.
                    </List.Item>
                    <List.Item>Unlimited Units Used</List.Item>
                </List>
            </div>

            <div className="flex gap-2">
                <Button
                    disabled={
                        isCompleteDevelopmentStagePending || isCancelPending
                    }
                    size="xs"
                    onClick={startFreeTrial}
                >
                    Start Free Trial
                </Button>
                <BillingMenu onCancel={onCancel} />
            </div>
        </div>
    );
};

export default DevelopmentSubscription;
